var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselButtonOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 21.5
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "m19 31 9-9-9-9"
}))));
export default SvgCarouselButtonOutline;